import { PagePerformance } from './page-performance';

export { PagePerformance };
